export const palette = {
  // primary: "#008859",
  primary: { dark: "#005f3e", main: "#008859", light: "#339e79" },
  secondary: { main: "#f1f3f4", contrastText: "#554854" },
  secondary2: { dark: "#6b546a", main: "#756372", light: "#8e818c", contrastText: "#554854" },

  success: { dark: "#005f3e", main: "#008859", light: "#339e79" },
  error: { dark: "#902f2f", main: "#cf4444", light: "#d86969" },
  info: { dark: "#00449A", main: "#0055b0", light: "#3377bf" },
  warning: { dark: "#85754f", main: "#bea66e", light: "#cbb78b" },

  // backgrounds

  avatars: "#bdbdbd",
  inputsAlt: "#d3d3d3",
  disabled: "#e1e1e1",
  modal: "#f4f4f4",
  content: "#f6f6f6",
  tabs: "#f9f9f9",
  tableHeaders: "#f9f9f9",
  switchers: "#fafafa",
  inputs: "#f1f3f4",

  background1: "#ececec",
  background2: "#d3d3d3",
  background3: "rgba(86, 70, 85, .5)",

  login: {
    main: '#fff',
    bg: '#008859',
  }
}
